export default __webpack_public_path__ + "static/media/e_doctor_horizontal_red@3x.56680022.png";